export enum UserTypes {
    Admin = 0,
    PowerUser = 1,
    User = 2
}